import NumBox from './src/NumBox'

NumBox.install = function (Vue) {
    Vue.component(NumBox.name, NumBox);
};

export default NumBox;